/* eslint-disable */

import 'whatwg-fetch';
import React from 'react';
import { PropTypes } from 'prop-types';
import { formatPrice, logger } from 'packages';
import shipping from './shipping';
import QuickViewButton from './quick-view-button';
import LazyLoad from 'react-lazyload';
import { itmToQueryString } from 'utils/itm';
import MultiCurrency from 'components/multi-currency/multi-currency';
import itemActions from 'state/actions/items';
/**
 * ITEMCARD
 * This is v1 of the item card in JSX. Relies on bootstrap and can only be used within the confines of bootstrap inheritence
 */
class ItemCard extends React.Component {
    static propTypes = {
        item: PropTypes.object,
        itm: PropTypes.shape({
            source: PropTypes.string,
            medium: PropTypes.string
        }),
        handleQuickViewClick: PropTypes.func,
        dispatch: PropTypes.func,
        ready: PropTypes.bool,
        lazy: PropTypes.shape({
            offset: PropTypes.number,
            once: PropTypes.bool,
            height: PropTypes.number
        }),
        itemLayout: PropTypes.string
    };

    static defaultProps = {
        handleQuickViewClick: () => {}
    };

    toggleWishlist(evt) {
        const {
            item: { itemId },
            dispatch
        } = this.props;
        evt.preventDefault();
        evt.stopPropagation();
        dispatch(itemActions.wishlist(itemId));
    }

    render() {
        const {
            item = {},
            ready,
            lazy,
            itm,
            handleQuickViewClick,
            itemLayout,
            preferredCurrency
        } = this.props;

        const itemUrl = `${item.url || item.itemUrl}${itmToQueryString(itm)}`;

        const colSize =
            itemLayout === 'layout-list' ? 'col-12' : 'col-6 col-sm-4 col-lg-3';

        return (
            <div
                id={`item-card-${item.itemId}`}
                data-item-loaded={ready ? 'true' : 'false'}
                className={`${colSize} item-card wish-list-placeholder px-2 ${
                    ready ? '' : 'item-card--loading'
                } ${item.existsInWishList ? 'exists-in-wish-list' : ''}`}>
                <div
                    className={`item-card-body ${
                        item.isNewToday ? 'item-card-body-newtoday' : ''
                    } ${item.hasDiscount ? 'item-card-body-discount' : ''} ${
                        item.displayHighlighted ? 'item-card-highlight' : ''
                    }`}>
                    <section
                        className={`giftwrap giftwrap-free-shipping ${
                            !item.showFreeShippingRibbon ? 'hidden' : ''
                        }`}>
                        <div className="giftwrap-ribbon">
                            <div className="giftwrap-text">Fri frakt!</div>
                        </div>
                    </section>

                    <section
                        className={`giftwrap giftwrap-on-display ${
                            !item.showOnDisplayRibbon ? 'hidden' : ''
                        }`}>
                        <div className="giftwrap-ribbon">
                            <div className="giftwrap-text">Utvald!</div>
                        </div>
                    </section>

                    <div className="item-card-image">
                        <figure className="item-card-figure">
                            <a href={itemUrl}>
                                {lazy ? (
                                    <LazyLoad {...lazy}>
                                        <img
                                            data-item-card-image
                                            src={item.imageUrl}
                                            alt={item.shortDescription}
                                        />
                                    </LazyLoad>
                                ) : (
                                    <img
                                        data-item-card-image
                                        src={item.imageUrl}
                                        alt={item.shortDescription}
                                    />
                                )}
                            </a>
                        </figure>
                    </div>

                    <div className="item-card-details">
                        {item.isNewToday ? (
                            <p className="item-card-flash">Ny idag</p>
                        ) : null}
                        <div className="item-card-details-data">
                            <div className="item-card-details-main">
                                <span className="item-card-details-discount-rate">
                                    -<span data-item-card-discount-rate>
                                        {item.discountRate}
                                    </span>%
                                </span>

                                <div
                                    className="item-card-details-header"
                                    title={item.shortDescription}>
                                    <a
                                        href={item.url || item.itemUrl}
                                        id={`item_${item.itemId}`}>
                                        {item.shortDescription}
                                    </a>
                                </div>
                                {item.sellerAlias && (
                                    <span className="item-card-details-seller">
                                        {item.sellerAlias}
                                        <span className="mx-2">|</span>
                                        <span>
                                            Betyg:{' '}
                                            {item.sellerDsrAverage ||
                                                'Ej bedömd'}
                                        </span>
                                    </span>
                                )}
                                <span
                                    className="item-card-details-time-left"
                                    data-item-card-details-time-left>
                                    {item.isShopItem ? (
                                        <span>Fast pris</span>
                                    ) : (
                                        <span
                                            className={`${
                                                item.isEndingSoon
                                                    ? 'item-card-details-time-ending-soon'
                                                    : ''
                                            }`}
                                            dangerouslySetInnerHTML={{
                                                __html: item.timeLeft
                                            }}
                                        />
                                    )}
                                </span>
                            </div>
                            <ol className="item-card-numbers">
                                {item.isShopItem ? (
                                    <li className="item-card-details-price-info">
                                        <span className="item-card-details-price">
                                            <span
                                                className="item-card-details-price-before-discount"
                                                data-item-card-details-price-before-discount>
                                                {item.priceBeforeDiscount}
                                            </span>
                                            <span
                                                className="item-card-details-price-amount"
                                                data-item-card-details-price
                                                data-item-card-details-discount-price>
                                                {formatPrice(item.price)}
                                            </span>
                                            <MultiCurrency
                                                amountInSek={item.price}
                                                preferredCurrency={
                                                    preferredCurrency
                                                }
                                            />
                                        </span>
                                    </li>
                                ) : null}
                                {(!item.isShopItem && item.currentBid) ||
                                (!item.isShopItem && item.price) ? (
                                    <li className="item-card-details-price-info">
                                        <span className="item-card-details-price">
                                            <span className="item-card-details-price-amount">
                                                {formatPrice(
                                                    item.currentBid ||
                                                        item.price
                                                )}
                                            </span>
                                            <span className="item-card-details-price-before-discount">
                                                {item.priceBeforeDiscount}
                                            </span>
                                            {item.showBids && (
                                                <span className="item-card-details-bids">
                                                    {item.totalBids} bud
                                                </span>
                                            )}
                                            <MultiCurrency
                                                amountInSek={
                                                    item.currentBid ||
                                                    item.price
                                                }
                                                preferredCurrency={
                                                    preferredCurrency
                                                }
                                            />
                                        </span>
                                    </li>
                                ) : null}

                                {!item.isShopItem && item.showBuyNow ? (
                                    <li className="item-card-details-buyitnow">
                                        <span className="item-card-details-buyitnow-bagde">
                                            Köp nu
                                        </span>
                                        <span className="item-card-details-buyitnow-price">
                                            {formatPrice(item.buyNowPrice)}
                                        </span>
                                        <MultiCurrency
                                            amountInSek={item.buyNowPrice}
                                            preferredCurrency={
                                                preferredCurrency
                                            }
                                        />
                                    </li>
                                ) : null}
                                {shipping(item)}
                            </ol>
                        </div>
                    </div>

                    {item.showSmbMessage ? (
                        <div className="shop-item-settings-message">
                            <h3 className="brand-text">
                                Nyhet för dig <br />som har butik!
                            </h3>
                        </div>
                    ) : null}

                    {ready ? (
                        <div className="item-card-icons d-flex align-items-center">
                            <div
                                className={`item-card-icon-action wish-list-item wishlist-selector ${
                                    item.existsInWishList
                                        ? 'wish-list-item--in-list'
                                        : ''
                                }`}>
                                <button
                                    className={`favorite-action wish-list-selector-add rounded ${
                                        item.existsInWishList
                                            ? 'wish-list-selector-remove'
                                            : ''
                                    }`}
                                    onClick={evt => this.toggleWishlist(evt)}>
                                    <span className="font-icon pr-2" />
                                    Spara i minneslistan
                                </button>
                            </div>
                            {handleQuickViewClick && (
                                <QuickViewButton
                                    handleQuickViewClick={() =>
                                        handleQuickViewClick(item.itemId)
                                    }
                                />
                            )}
                            {item.showShopItemSettings ? (
                                <div className="item-card-icon-action shop-item-settings-icon">
                                    <button
                                        className="shop-item-settings-action"
                                        data-shop-item-settings-action>
                                        <span className="font-icon" />
                                    </button>
                                </div>
                            ) : null}
                        </div>
                    ) : null}
                </div>
            </div>
        );
    }
}

export default ItemCard;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/item-card/item-card.jsx